import _classCallCheck from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { useMemo } from 'react';
import { ENDPOINTS } from '../../endpoints';
import { Service } from '../base';
import dynamicAxios from '../../utils/axios';
import useServices from '../../hooks/useServices';

var ServiceAmbassadors = /*#__PURE__*/function (_Service) {
  _inherits(ServiceAmbassadors, _Service);

  var _super = _createSuper(ServiceAmbassadors);

  function ServiceAmbassadors() {
    _classCallCheck(this, ServiceAmbassadors);

    return _super.apply(this, arguments);
  }

  _createClass(ServiceAmbassadors, [{
    key: "me",
    value: function me() {
      return this.axiosInstance.get(ENDPOINTS.ambassadors.me);
    }
  }, {
    key: "getMetrics",
    value: function getMetrics(fromDate, toDate, challengeId) {
      return this.axiosInstance.get(ENDPOINTS.ambassadors.metrics, {
        params: {
          from_date: fromDate,
          to_date: toDate,
          challenge_id: challengeId
        }
      });
    }
  }, {
    key: "getChallenges",
    value: function getChallenges() {
      return this.axiosInstance.get(ENDPOINTS.ambassadors.challenges);
    }
  }, {
    key: "acceptTermsAndConditions",
    value: function acceptTermsAndConditions(userId) {
      return this.axiosInstance.get(ENDPOINTS.ambassadors.acceptTermsAndConditions, {
        params: {
          user_id: userId
        }
      });
    }
  }, {
    key: "getJobPositionPerformanceMetrics",
    value: function getJobPositionPerformanceMetrics(fromDate, toDate, challengeId) {
      return this.axiosInstance.get(ENDPOINTS.ambassadors.jobPositionPerformanceMetrics, {
        params: {
          from_date: fromDate,
          to_date: toDate,
          challenge_id: challengeId
        }
      });
    }
  }, {
    key: "getManagedChallengers",
    value: function getManagedChallengers() {
      return this.axiosInstance.get(ENDPOINTS.ambassadors.managed);
    }
  }, {
    key: "getManagedTeamAggregate",
    value: function getManagedTeamAggregate(fromDate, toDate) {
      return this.axiosInstance.get(ENDPOINTS.ambassadors.managedAggregate, {
        params: {
          from_date: fromDate,
          to_date: toDate
        }
      });
    }
  }, {
    key: "getManagedRoster",
    value: function getManagedRoster(fromDate, toDate) {
      return this.axiosInstance.get(ENDPOINTS.ambassadors.managedRoster, {
        params: {
          from_date: fromDate,
          to_date: toDate
        }
      });
    }
  }, {
    key: "getManagedMetrics",
    value: function getManagedMetrics(ambassadorCode, fromDate, toDate, challengeId) {
      return this.axiosInstance.get(ENDPOINTS.ambassadors.managedMetrics(ambassadorCode), {
        params: {
          from_date: fromDate,
          to_date: toDate,
          challenge_id: challengeId
        }
      });
    }
  }, {
    key: "getManagedJobPositionPerformanceMetrics",
    value: function getManagedJobPositionPerformanceMetrics(ambassadorCode, fromDate, toDate, challengeId) {
      return this.axiosInstance.get(ENDPOINTS.ambassadors.managedJobPositionPerformanceMetrics(ambassadorCode), {
        params: {
          from_date: fromDate,
          to_date: toDate,
          challenge_id: challengeId
        }
      });
    }
  }]);

  return ServiceAmbassadors;
}(Service);

export function useAmbassadorService() {
  var _useServices = useServices(),
      baseUrl = _useServices.baseUrl,
      jwt = _useServices.jwt;

  return useMemo(function () {
    return new ServiceAmbassadors(dynamicAxios(baseUrl, jwt));
  }, [baseUrl, jwt]);
}
export * from './types';
export default useAmbassadorService;